import {RestService} from "@/services/rest/RestService";
import {UserRegistrationRuleEndpointsApi} from "@/api/pharma-auth-urr";
import {
    UrrSimulationInputRestDto,
    UrrSimulationOutputRestDto,
    UserRegistrationOverviewResultsRestDto
} from "@/api/pharma-auth-urr/models";
import {ValueEnum} from "@/api/enums/value-enum";

export class UserRegistrationRuleRestService extends RestService {

    private apiService: UserRegistrationRuleEndpointsApi;

    protected constructor() {
        super();

        this.apiService = new UserRegistrationRuleEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().authUrl);
    }

    public async findUserRegistrationRules(): Promise<UserRegistrationOverviewResultsRestDto> {
        const response = await this.apiService.findUserRegistrationRules();

        return response.data;
    }

    public async updateUrrStatus(statusValue: ValueEnum, ruleId: string): Promise<void> {
        await this.apiService.updateUrrStatusCode({value: statusValue}, ruleId);
    }

    public async simulate(input: UrrSimulationInputRestDto, ruleId: string): Promise<UrrSimulationOutputRestDto> {
        const response = await this.apiService.simulateUserRegistrationRule(input, ruleId);

        return response.data;
    }

}
